(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["delivery-estimate"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('delivery-window')) return;

    const DAY_MS = 86400000;
    // A calendar day is counted as whole days since 1970-01-01: no time zone or daylight-saving change can shift it.
    const dayOf = (year, month, date) => Math.round(Date.UTC(year, month - 1, date) / DAY_MS);
    const weekdayOf = (day) => (((day + 4) % 7) + 7) % 7; // 1970-01-01 was a Thursday
    const nthWeekday = (year, month, weekday, nth) => {
      if (nth > 0) {
        const first = dayOf(year, month, 1);
        return first + ((weekday - weekdayOf(first) + 7) % 7) + (nth - 1) * 7;
      }
      const last = dayOf(year, month + 1, 1) - 1;
      return last - ((weekdayOf(last) - weekday + 7) % 7);
    };
    // A holiday on a fixed date is observed the Friday before when it falls on a Saturday, the Monday after on a Sunday.
    const observed = (day) => (weekdayOf(day) === 6 ? day - 1 : weekdayOf(day) === 0 ? day + 1 : day);
    // The 11 US federal holidays of a year (observed dates). New Year's Day of the next year may be observed on Dec 31.
    const federalHolidays = (year) => [
      observed(dayOf(year, 1, 1)),
      nthWeekday(year, 1, 1, 3),
      nthWeekday(year, 2, 1, 3),
      nthWeekday(year, 5, 1, -1),
      observed(dayOf(year, 6, 19)),
      observed(dayOf(year, 7, 4)),
      nthWeekday(year, 9, 1, 1),
      nthWeekday(year, 10, 1, 2),
      observed(dayOf(year, 11, 11)),
      nthWeekday(year, 11, 4, 4),
      observed(dayOf(year, 12, 25)),
    ];

    const clockIn = (now, timeZone) => {
      const parts = {};
      const format = new Intl.DateTimeFormat('en-US', {
        timeZone,
        hourCycle: 'h23',
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      });
      for (const {type, value} of format.formatToParts(now)) parts[type] = Number(value);
      return {day: dayOf(parts.year, parts.month, parts.day), minutes: (parts.hour % 24) * 60 + parts.minute};
    };

    /**
     * First and last delivery days (whole days since 1970-01-01) for an order placed at `now`.
     * @param {Date} now
     * @param {Object} plan - minDays and maxDays (business days), cutoff (HH:MM or none), timeZone (IANA), holidays (us_federal or none)
     */
    const deliveryDays = (now, plan) => {
      const {minDays, maxDays, cutoff, timeZone, holidays} = plan;
      if (!Number.isInteger(minDays) || !Number.isInteger(maxDays) || minDays < 1 || maxDays < minDays || maxDays > 90) {
        throw new RangeError('Delivery days must be whole numbers, 1 or more, the shortest first.');
      }
      const cutoffMatch = /^(\d{2}):(\d{2})$/.exec(cutoff || '');
      if (cutoff && cutoff !== 'none' && !cutoffMatch) throw new RangeError('The order cutoff must be HH:MM.');
      const clock = clockIn(now, timeZone);
      const holidaysByYear = new Map();
      const closed = (day) => {
        const weekday = weekdayOf(day);
        if (weekday === 0 || weekday === 6) return true;
        if (holidays !== 'us_federal') return false;
        const year = new Date(day * DAY_MS).getUTCFullYear();
        if (!holidaysByYear.has(year)) {
          holidaysByYear.set(year, new Set([...federalHolidays(year), ...federalHolidays(year + 1)]));
        }
        return holidaysByYear.get(year).has(day);
      };
      let start = clock.day;
      const late = cutoffMatch && clock.minutes >= Number(cutoffMatch[1]) * 60 + Number(cutoffMatch[2]);
      if (closed(start) || late) {
        do start += 1;
        while (closed(start));
      }
      const after = (count) => {
        let day = start;
        for (let left = count; left > 0; ) {
          day += 1;
          if (!closed(day)) left -= 1;
        }
        return day;
      };
      return {start, first: after(minDays), last: after(maxDays)};
    };

    const dateLabel = new Intl.DateTimeFormat('en-US', {timeZone: 'UTC', weekday: 'short', month: 'short', day: 'numeric'});
    const showDay = (day) => dateLabel.format(new Date(day * DAY_MS));
    const deliveryLabel = (now, plan) => {
      const {first, last} = deliveryDays(now, plan);
      return first === last ? showDay(first) : `${showDay(first)} – ${showDay(last)}`;
    };

    class DeliveryWindow extends HTMLElement {
      static deliveryDays = deliveryDays;
      static deliveryLabel = deliveryLabel;

      connectedCallback() {
        this.update();
        // The product section may be morphed after a variant change: put the dates back if the range comes back.
        this.observer ??= new MutationObserver(() => this.update());
        this.observer.observe(this, {childList: true, characterData: true, subtree: true});
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      update() {
        try {
          const label = deliveryLabel(new Date(), {
            minDays: Number(this.dataset.minDays),
            maxDays: Number(this.dataset.maxDays),
            cutoff: this.dataset.cutoff,
            timeZone: this.dataset.timeZone,
            holidays: this.dataset.holidays,
          });
          if (this.textContent !== label) this.textContent = label;
        } catch (error) {
          // Keep the range in business days written by the page.
        }
      }
    }

    customElements.define('delivery-window', DeliveryWindow);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["faq-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('faq-tabs')) {
    class FaqTabs extends HTMLElement {
      connectedCallback() {
        this.build();
        // Theme editor: a topic added, removed or moved rebuilds the pills; a selected block shows its topic.
        this.observer = new MutationObserver(() => this.build());
        this.observer.observe(this.querySelector('.faq-tabs__panels'), {childList: true});
        this.onSelect = (event) => {
          const panel = event.target instanceof Element ? event.target.closest('.faq-tab') : null;
          if (panel && this.panels.includes(panel)) this.select(this.panels.indexOf(panel), false);
        };
        document.addEventListener('shopify:block:select', this.onSelect);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        document.removeEventListener('shopify:block:select', this.onSelect);
      }

      build() {
        const list = this.querySelector('.faq-tabs__list');
        this.panels = [...this.querySelectorAll('.faq-tab')].filter((panel) => panel.closest('faq-tabs') === this);
        const selected = Math.max(0, this.panels.findIndex((panel) => panel.dataset.selected === 'true'));
        list.textContent = '';
        this.buttons = this.panels.map((panel, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'faq-tabs__pill';
          button.id = `${panel.id}-tab`;
          button.setAttribute('role', 'tab');
          button.setAttribute('aria-controls', panel.id);
          button.innerHTML = panel.querySelector('.faq-tab__title')?.innerHTML ?? '';
          button.addEventListener('click', () => this.select(index, false));
          button.addEventListener('keydown', (event) => this.onKey(event, index));
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', button.id);
          panel.setAttribute('tabindex', '0');
          list.append(button);
          return button;
        });
        list.hidden = this.panels.length < 2;
        this.toggleAttribute('data-tabs', this.panels.length > 1);
        if (this.panels.length > 1) this.select(selected, false);
        else this.panels.forEach((panel) => (panel.hidden = false));
      }

      select(index, focus) {
        this.panels.forEach((panel, at) => {
          const active = at === index;
          panel.hidden = !active;
          panel.dataset.selected = String(active);
          this.buttons[at].setAttribute('aria-selected', String(active));
          this.buttons[at].tabIndex = active ? 0 : -1;
        });
        if (focus) this.buttons[index].focus();
      }

      onKey(event, index) {
        const last = this.buttons.length - 1;
        const next = {ArrowRight: index + 1, ArrowDown: index + 1, ArrowLeft: index - 1, ArrowUp: index - 1, Home: 0, End: last}[event.key];
        if (next === undefined) return;
        event.preventDefault();
        this.select((next + last + 1) % (last + 1), true);
      }
    }
    customElements.define('faq-tabs', FaqTabs);
  }
  } catch(e) { console.error(e); }
})();

})();
